import React from "react";
import { useTranslation } from "react-i18next";
import InputGroup from "../../../common/inputs/InputGroup";
import { InputTypes, TextInputType } from "../../../../constants/enums";
import { Styles } from "./styles";

const Step2 = ({
  formik,
  onBack,
  isSubmitting,
  isAr,
  instanceId = "",
  onEnableValidation,
  isInDetailsPage = false,
  isLoggedIn = false,
}) => {
  const { t } = useTranslation();
  // const isAnonymous = formik.values.isAnonymous;
  const showErrors = formik.submitCount > 0;
  const idPrefix = instanceId ? `donation-${instanceId}-` : "donation-";

  const fields = [
    {
      name: "firstName",
      label: "First name",
      id: `${idPrefix}first-name`,
      type: InputTypes.textInput,
      textInputType: TextInputType.text,
      required: true,
      value: formik.values.firstName,
      // value: isLoggedIn ? "" : formik.values.firstName,
      onChange: formik.handleChange,
      errorMessage: formik.errors?.firstName,
      placeholder: t("First name"),
      // isDisabled: isLoggedIn,
    },
    {
      name: "lastName",
      label: "Last name",
      id: `${idPrefix}last-name`,
      type: InputTypes.textInput,
      textInputType: TextInputType.text,
      required: true,
      // value: isLoggedIn ? "" : formik.values.lastName,
      value: formik.values.lastName,
      onChange: formik.handleChange,
      errorMessage: formik.errors?.lastName,
      placeholder: t("Last name"),
      // isDisabled: isLoggedIn,
    },
    {
      name: "email",
      label: "Email address",
      id: `${idPrefix}email`,
      type: InputTypes.textInput,
      textInputType: TextInputType.email,
      required: true,
      // value: isLoggedIn ? "" : formik.values.email,
      value: formik.values.email,
      onChange: formik.handleChange,
      errorMessage: formik.errors?.email,
      placeholder: t("Email address"),
      // isDisabled: isLoggedIn,
    },
    {
      name: "isAnonymous",
      label: "Donate as anonymous",
      id: `${idPrefix}anonymous`,
      type: InputTypes.checkbox,
    },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    formik.handleSubmit();
  };

  return (
    <Styles isAr={isAr} $isInDetailsPage={isInDetailsPage}>
      <div className="donation-details-card">
        <div className="details-header">
          <h2 className="details-title">{t("Enter your details")}</h2>
          {onBack && (
            <button
              type="button"
              className="details-back"
              onClick={onBack}
              aria-label={t("Back")}
            >
              <span className="details-back-arrow">{isAr ? "‹" : "›"}</span>
            </button>
          )}
        </div>

        <form onSubmit={handleSubmit} className="details-form">
          {fields.map((field) => (
            <div
              key={field.name}
              className={
                field.type === InputTypes.checkbox
                  ? "details-checkbox"
                  : "details-field"
              }
            >
              <InputGroup
                field={field}
                formik={formik}
                validateOnChange={showErrors}
              />
            </div>
          ))}

          <button
            type="submit"
            className="details-submit"
            disabled={isSubmitting}
            onClick={onEnableValidation}
          >
            {isSubmitting ? t("Submitting...") : t("Continue")}
          </button>
        </form>
      </div>
    </Styles>
  );
};

export default Step2;
